import { bom } from './../../../../model/inventory.model';
import { Component, OnInit, ViewChild } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { gridPageRequest, gridPagination } from '../../../../model/common/common.model';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { InventoryService } from '../../../../services/inventory.service';
import { BOMGridResponse } from '../../../../model/inventory.model';
import { ConfirmationService, MessageService } from 'primeng/api';
import _ from 'lodash';
import { Table } from 'primeng/table';
import { ReportLookupComponent } from '../../../Reports/report-lookup/report-lookup.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ReportCenterService } from '../../../../services/report-center.service';

@Component({
  selector: 'app-list-bom',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './list-bom.component.html',
  styleUrl: './list-bom.component.scss'
})
export class ListBOMComponent implements OnInit {
  @ViewChild('dt1') dt1: Table | undefined;

  loader: boolean = false;
  selectedbillofmaterial: bom[] = [];
  searchKey: any;
  unitLabel: string = '';

  result: BOMGridResponse = {
    bom: [],
    totalRecords: 0
  }
  gridPagination: gridPagination = {
    first: 0,
    last: 0,
    totalRecords: 10
  }
  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 10,
    id: 0
  }

  constructor(private route: Router, private billofmaterialservice: InventoryService, private messageService: MessageService, private confirmationService: ConfirmationService, public dialogService: DialogService,
      public ref: DynamicDialogRef, private reportService : ReportCenterService, public inventoryService: InventoryService) { }

  ngOnInit(): void {
    document.title = 'List BOM';
    this.searchEffect();
    this.getBillOfMaterial(this.pageRequest)
    this.inventoryService.getUnitByAppKey('unitNameLabel').subscribe((res: any) => {
      this.unitLabel = res?.data || 'Unit';
    });
  }

  getBillOfMaterial(query: gridPageRequest) {
    this.billofmaterialservice.getAllBillOfMaterials(query).subscribe({
      next: data => {
        this.result = data as BOMGridResponse;
        this.pageCalculation();
      },
      error: error => {
      }
    })
  }

  createBOM() {
    this.route.navigate(['/home/createBillofMaterial'])
  }


  updateBOM(data?: any) {
    if (data) {
      this.route.navigate(['/home/createBillofMaterial'], { queryParams: { 'bomId': data }, skipLocationChange: true },);
    } else {
      this.route.navigate(['/home/createBillofMaterial'], { queryParams: { 'bomId': this.selectedbillofmaterial[0].bomId }, skipLocationChange: true },);
    }
  }

  deleteBOM() {
    this.confirmationService.confirm({
      header: 'Are you sure?',
      message: 'Please confirm to proceed.',
      accept: () => {
        this.loader = true;
        if (this.selectedbillofmaterial && this.selectedbillofmaterial.length > 0) {
          var productBoMId = _.map(this.selectedbillofmaterial, 'bomId');
          this.billofmaterialservice.deletebom(productBoMId).subscribe({
            next: data => {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Bill Of Material deleted successfully.' });
              this.loader = false;
              this.selectedbillofmaterial = [];
              this.getBillOfMaterial(this.pageRequest);
            },
            error: error => {
              this.loader = false;
              console.log(error);
            }
          });
        }
      },
      reject: () => {
      }
    });
  }

  pageCalculation() {
    let last = (this.pageRequest.pageIndex * this.pageRequest.pageSize) + this.pageRequest.pageSize;
    this.gridPagination.first = (this.pageRequest.pageIndex * this.pageRequest.pageSize) + 1;
    this.gridPagination.last = last < this.result.totalRecords ? last : this.result.totalRecords;
    this.gridPagination.totalRecords = this.result.totalRecords;
  }

  loadBom(event: any) {
    this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
    this.getBillOfMaterial(this.pageRequest);
  }

  searchBom(): void {
    const filterValue = this.searchKey?.trim();

    if (!filterValue) {
      return;
    }

    this.billofmaterialservice.autoSearchBom(filterValue).subscribe(
      (data: any) => {
        if (data) {

          this.result = Array.isArray(data) ? { bom: data } : data;

          if (this.dt1) {
            this.dt1.first = 0;
          }
        } else {
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  refreshData(): void {
    if (this.dt1) {
      this.dt1.first = 0;
      this.dt1.clear();
    }
    this.searchKey = '';
    this.pageRequest.pageIndex = 0;
    this.pageRequest.pageSize = 50;
    this.getBillOfMaterial(this.pageRequest);
  }

showReport(value: any): void {
  const formCode = 'BOM';

  this.reportService.getReportName(formCode).subscribe({
    next: (report: any) => {
      let bomId = value.bomId;
      const bomIdStr = bomId ? String(bomId) : '';
      const sanitizedId = bomIdStr ? bomIdStr.replace(/[^a-zA-Z0-9]/g, "_"): 'BOM';
      document.title = sanitizedId;
      this.ref = this.dialogService.open(ReportLookupComponent, {
        header: report.formName,
        width: '100%',
        data: {
          OrderNo: bomIdStr,
          ReportName: sanitizedId,
          ReportPath: report.path
        }
      });

      this.ref.onClose.subscribe(() => {
        this.searchKey = '';
        document.title = 'BOM List';
      });
    },
    error: (err: any) => {
      console.error('Report not found for form code:', formCode, err);
    }
  });
}

placeholder: string = 'Search By ';
  private messages: string[] = ['Product Name', 	'Unit',	'Unit Of Measure',	'BOM Type',	'Created By'];  
  private messageIndex = 0;
  private charIndex = 0;


  searchEffect() {
    const base = 'Search By ';
    const typeNextChar = () => {
      if (this.charIndex <= this.messages[this.messageIndex].length) {
        this.placeholder = base + this.messages[this.messageIndex].substring(0, this.charIndex);
        this.charIndex++;
        setTimeout(typeNextChar, 150);
      } else {
        setTimeout(() => {
          this.messageIndex = (this.messageIndex + 1) % this.messages.length;
          this.charIndex = 0;
          typeNextChar();
        }, 1000);
      }
    };
    typeNextChar();
  }

}
